import { defineComponent as _defineComponent } from 'vue'
import EstateMapEmbeddedOptions from "@/components/EstateMapEmbeddedOptions.vue";
  import HeaderCustomer from "@/components/HeaderCustomer.vue";
  import LoginOrCreateModal from "@/components/ui/modals/LoginOrCreateModal.vue";
  import LoginModal from "@/components/ui/modals/LoginModal.vue";
  import RegistrationModal from "@/components/ui/modals/RegistrationModal.vue";
  import ContactUsModal from "@/components/ui/modals/ContactUsModal.vue";
  import EstateMap from "@/components/EstateMap.vue";
  import StageMap from "@/components/StageMap.vue";
  import ReserveLotModal from "@/components/ui/modals/ReserveLotModal.vue";
  import ShareMapModal from "@/components/ui/modals/ShareMapModal.vue";
  import SuccessInitialHoldModal from "@/components/ui/modals/SuccessInitialHoldModal.vue";
  import initialHoldWithPartnerModal from "@/components/ui/modals/InitialHoldWithPartnerModal.vue";
  import BuilderRequestQuoteModal from "@/components/ui/modals/BuilderRequestQuoteModal.vue";
  import { useGtag } from "vue-gtag-next";
  import store from "@/store";
  import { computed, onMounted, onUnmounted, ref, watch } from "vue";
  import { AuthParams } from "@/types";
  import { ContactUsForm } from "@/types/ContactUsForm";
  import { UserRoles } from "@/enums/UserRoles";
  import router from "@/router";
  import { useEstateVersionRedirect } from "@/composables/useEstateVersionRedirect";
  import { CreateUser } from "@/types/CreateUser";
  import { LotMapInterface } from "@/types/LotMapInterface";
  import LocalStorageService from "@/services/localStorage.service";
  import ResetPasswordModal from "@/components/ui/modals/ResetPasswordModal.vue";
  import { isLogged } from "@/features/useUser";
  import {
    changePrimaryColor,
    resetPrimaryColor,
  } from "@/helpers/customer/changePrimaryColor";
  import StageList from "@/components/StageList.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import InitialHoldModal from "@/components/ui/modals/InitialHoldModal.vue";
  import { MapPages } from "@/enums/MapPages";
  import { EmbeddedMapQueries } from "@/types/EmbeddedMapQueries";
  import { POSITION, useToast } from "vue-toastification";
  import InfoWithIcon from "@/components/ui/InfoWithIcon.vue";
  import { EstateInterface } from "@/types/EstateInterface";

  const mobileLayoutWidth = 680;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'EstateMapView',
  setup(__props, { expose: __expose }) {
  __expose();

  const { isDesktop } = useIsDesktop(mobileLayoutWidth);
  const loginError = ref("");
  const userData = ref({});
  const isOpenedLoginOrCreateModal = ref(false);
  const isOpenedLoginModal = ref(false);
  const isOpenedRegistrationModal = ref(false);
  const isOpenedContactUsModal = ref(false);
  const isLoadingContactUsModal = ref(false);
  const isOpenedResetPasswordModal = ref(false);
  const isOpenedShareMapModal = ref(false);
  const zoom = ref(1);

  const estate = ref<EstateInterface | null>(null);
  const showStageMap = computed(() => {
    return router.currentRoute.value.query.stageId;
  });
  const headerOverAll = ref(false);
  const showReserveModal = ref(false);
  const lotBuilderIconHover = ref(false);
  const lotForReserve = ref<LotMapInterface | null>(null);
  const isQuestionWithLot = ref(false);
  const registrationMessage = ref("");
  const forgotPasswordMessage = ref("");
  const isOpenedInitialHoldModalWithPartner = ref(false);
  const successfulInitialRequestOpen = ref(false);
  const isOpenedInitialHoldModal = ref(false);
  const { estateId } = router.currentRoute.value.params;
  const customerId = store.state.user?.data?._id;
  const transitionName = ref("fade");
  const urlRedirectAfterVerifyEmail = ref("");
  const { isEmbedded, defaultView, showLogo } = embeddedOptions();
  const viewType = ref<"list" | "map">(defaultView);
  const isOpenedBuilderRequestQuoteModal = ref(false);
  const getBtnClassByViewType = computed(() => {
    return viewType.value === "list" ? "map-view" : "list-view";
  });
  const { pageview } = useGtag();
  const currentUrl = ref(`/estate/${estateId}`);
  const track = () => {
    pageview({ page_path: currentUrl.value, page_title: estate.value?.title });
  };
  const toast = useToast();
  const mouseX = ref(0);
  const mouseY = ref(0);
  const businessId = computed(
    () => router.currentRoute.value.query?.businessId
  );

  const onRegister = () => {
    urlRedirectAfterVerifyEmail.value = `/estate/${estateId}/waitlist`;

    if (isEmbedded) {
      if (businessId.value) {
        window.open(
          `/estate/${estateId}/waitlist?businessId=${businessId.value}&embed=true`
        );
        return;
      }

      window.open(`/estate/${estateId}/waitlist?embed=true`);
      return;
    }

    if (isLogged()) {
      window.open(`/estate/${estateId}/waitlist`);
    } else {
      router.push(`/estate/${estateId}/waitlist`);
    }
  };

  function embeddedOptions() {
    const querys = router.currentRoute.value.query as EmbeddedMapQueries;
    const view: "list" | "map" = querys.default === "list" ? "list" : "map";

    return {
      isEmbedded: querys.embed === "true",
      defaultView: view,
      showLogo: querys.powered_by_logo !== "false",
    };
  }
  function showContactWithQuestion() {
    isQuestionWithLot.value = true;
    isOpenedContactUsModal.value = true;
  }
  const backToReserve = () => {
    transitionName.value = "fade";
    isOpenedContactUsModal.value = false;
    isOpenedInitialHoldModal.value = false;
    isOpenedInitialHoldModalWithPartner.value = false;
    isQuestionWithLot.value = false;
    isOpenedBuilderRequestQuoteModal.value = false;
    showReserveModal.value = true;
    const scrollPosition = window.scrollY;

    router.replace({
      path: router.currentRoute.value.path,
      query: {
        ...router.currentRoute.value.query,
        lotId: lotForReserve.value?.lotId?._id,
      },
    });
    scrollToSavedPosition(scrollPosition);
  };

  function onMessage() {
    isOpenedContactUsModal.value = true;
    showReserveModal.value = false;
  }
  function onCloseLoginOrCreateModal() {
    closeLoginOrCreateModal();
    clearUnauthorizedParam();
  }
  function onCloseLoginModal() {
    isOpenedLoginModal.value = false;
    loginError.value = "";
    clearUnauthorizedParam();
  }
  function onSelectLogin() {
    closeLoginOrCreateModal();
    isOpenedLoginModal.value = true;
  }
  function onSelectCreate() {
    closeLoginOrCreateModal();
    isOpenedRegistrationModal.value = true;
  }
  function closeLoginOrCreateModal() {
    isOpenedLoginOrCreateModal.value = false;
  }
  function onCloseRegistrationModal() {
    isOpenedRegistrationModal.value = false;
    clearUnauthorizedParam();
    registrationMessage.value = "";
  }
  function onCloseContactUsModal() {
    isOpenedContactUsModal.value = false;
    isQuestionWithLot.value = false;
  }
  function onLogin(form: AuthParams) {
    Object.assign(userData.value, { login: form });
    signIn(form);
  }

  function onJoin() {
    isOpenedLoginModal.value = false;
    isOpenedRegistrationModal.value = true;
  }
  function onLoginFromRegistration() {
    isOpenedLoginModal.value = true;
    isOpenedRegistrationModal.value = false;
  }
  function onForgotPassword() {
    isOpenedLoginModal.value = false;
    isOpenedResetPasswordModal.value = true;
  }

  const updateHeaderOverAll = (value: boolean) => {
    headerOverAll.value = value;
  };

  const onOpenPartnerModal = () => {
    isOpenedInitialHoldModal.value = false;
    isOpenedInitialHoldModalWithPartner.value = true;
  };

  const backToSelectHoldType = () => {
    isOpenedInitialHoldModal.value = false;
    isOpenedInitialHoldModalWithPartner.value = false;
  };

  const onHoldRequest = () => {
    isOpenedInitialHoldModal.value = true;
  };

  const onCloseHoldRequest = () => {
    isQuestionWithLot.value = false;
    isOpenedInitialHoldModal.value = false;
  };
  const onCloseHoldRequestWithPartner = () => {
    isOpenedInitialHoldModalWithPartner.value = false;
  };
  const onSendHoldRequest = () => {
    isOpenedInitialHoldModal.value = false;
    isQuestionWithLot.value = false;
    successfulInitialRequestOpen.value = true;
  };
  const onRequestQuote = () => {
    isOpenedBuilderRequestQuoteModal.value = true;
  };

  function onSendInResetPasswordModal(email: string) {
    forgotPasswordMessage.value = "";
    store
      .dispatch("user/forgotPassword", email.toLowerCase())
      .then(() => {
        isOpenedResetPasswordModal.value = false;
      })
      .catch((error) => {
        forgotPasswordMessage.value = error.response.data.message;
      });
  }
  function onCloseResetPasswordModal() {
    forgotPasswordMessage.value = "";
    isOpenedResetPasswordModal.value = false;
    clearUnauthorizedParam();
  }
  const signIn = (data: AuthParams) => {
    loginError.value = "";
    store
      .dispatch("user/login", data)
      .then(() => {
        isOpenedLoginModal.value = false;

        if (store.state.user.redirectLink) {
          transitionName.value = "";
          const route = router.resolve(store.state.user.redirectLink);

          window.open(route.href, isEmbedded ? "_blank" : "_self");
        } else if (urlRedirectAfterVerifyEmail.value) {
          transitionName.value = "";
          const route = router.resolve(urlRedirectAfterVerifyEmail.value);

          window.open(route.href, isEmbedded ? "_blank" : "_self");
        }
      })
      .catch((error) => {
        if (error.response.data.statusCode === 403) {
          LocalStorageService.set(
            "urlAfterVerify",
            router.currentRoute.value.fullPath
          );
          router.push({
            name: "RegistrationVerifyView",
            params: { userEmail: data.email.toLowerCase() },
          });
        } else {
          loginError.value = error.response.data.message;
        }
      });
  };
  const signUp = (data: CreateUser) => {
    registrationMessage.value = "";
    userData.value = data;
    const callbackUrl = store.state.user.redirectLink?.fullPath
      ? store.state.user.redirectLink.fullPath
      : urlRedirectAfterVerifyEmail.value
      ? urlRedirectAfterVerifyEmail.value
      : `/estate/${estateId}`;
    const { email, ...props } = data;
    const normalizedData = {
      ...props,
      email: email.toLowerCase(),
    };

    store
      .dispatch("user/signUp", {
        data: normalizedData,
        params: { url: callbackUrl, estateId },
      })
      .then(() => {
        isOpenedRegistrationModal.value = false;
        transitionName.value = "";
        LocalStorageService.set("urlAfterVerify", callbackUrl);
        const route = router.resolve({
          name: "RegistrationVerifyView",
          params: { userEmail: data.email.toLowerCase(), estateId },
        });

        urlRedirectAfterVerifyEmail.value = "";

        if (isEmbedded) {
          window.open(route.href, "_blank");
        } else {
          router.push(route);
        }
      })
      .catch((error) => {
        if (error.response.data.statusCode === 409) {
          registrationMessage.value = error.response.data.message;
        }
      });
  };

  function onSendContactUsModal(data: ContactUsForm) {
    isLoadingContactUsModal.value = true;
    store
      .dispatch("estate/sendContactEmail", {
        estateId,
        data,
        businessId: businessId.value,
      })
      .then(() => {
        isOpenedContactUsModal.value = false;
        isQuestionWithLot.value = false;
      })
      .catch(() => {
        toast.error("Error on sending contact form", {
          position: POSITION.TOP_LEFT,
        });
      })
      .finally(() => {
        isLoadingContactUsModal.value = false;
      });
  }
  function fetchEstate() {
    store.dispatch("estate/getEstate", estateId).then((response) => {
      estate.value = response.data;
      changePrimaryColor(estate.value.iconColor);
    });
  }
  const onReserve = (lot: LotMapInterface) => {
    scrollTopEmbedded();
    transitionName.value = "fade";
    lotForReserve.value = lot;
    showReserveModal.value = true;
    const scrollPosition = window.scrollY;

    router.push({
      path: router.currentRoute.value.path,
      query: { ...router.currentRoute.value.query, lotId: lot.lotId._id },
    });
    scrollToSavedPosition(scrollPosition);
  };
  const closeReserveModal = (needUpdateRoute: boolean) => {
    showReserveModal.value = false;
    const scrollPosition = window.scrollY;

    if (needUpdateRoute) {
      router.push({
        path: router.currentRoute.value.path,
        query: { ...router.currentRoute.value.query, lotId: null },
      });
      scrollToSavedPosition(scrollPosition);
    }
  };
  const onReserveLot = (url: string) => {
    urlRedirectAfterVerifyEmail.value = url;
    transitionName.value = "";
    const route = router.resolve({
      name: "EOIRequest",
      params: {
        estateId,
        lotId: lotForReserve.value?.lotId?._id,
      },
      query: {
        stageId: lotForReserve.value?.stageId?._id,
        ...(businessId.value && { businessId: businessId.value }),
      },
    });

    window.open(route.href, isEmbedded ? "_blank" : "_self");
  };

  function onLogout() {
    store.dispatch("user/logout");
  }
  function onMyAccount() {
    router.push({ name: "Customer" });
  }
  function clearUnauthorizedParam() {
    if (router.currentRoute.value.params.unauthorized) {
      router.push({
        name: "EstateMap",
        params: { estateId },
        query: router.currentRoute.value.query,
      });
    }
  }

  const scrollToSavedPosition = (position: number) => {
    setTimeout(() => {
      window.scrollTo(0, position);
    }, 20);
  };

  const openLoginModal = () => {
    transitionName.value = "fade";
    isOpenedLoginModal.value = true;
    showReserveModal.value = false;
  };

  const openRegistrationModal = () => {
    transitionName.value = "fade";
    isOpenedRegistrationModal.value = true;
    showReserveModal.value = false;
  };

  const changeView = () => {
    viewType.value = viewType.value === "map" ? "list" : "map";
  };

  const handleResize = (event: ResizeObserverEntry[]) => {
    parent.postMessage(
      {
        height: event[0].contentRect.height,
        width: event[0].contentRect.width,
      },
      "*"
    );
  };

  const scrollTopEmbedded = () => {
    if (!isEmbedded) {
      return;
    }

    parent.postMessage({ event: "scroll" }, "*");
  };

  const updateZoom = (value: number) => {
    const newZoom = zoom.value + value;

    if (newZoom >= 1 && newZoom <= 2.6) {
      zoom.value = newZoom;
    }
  };

  const { checkEstateVersionAndRedirect } = useEstateVersionRedirect();

  const observerEmbedded = new ResizeObserver(handleResize);

  onMounted(() => {
    checkEstateVersionAndRedirect(estateId as string, UserRoles.CUSTOMER);
    track();
    fetchEstate();

    if (isEmbedded) {
      observerEmbedded.observe(document.body);
    }
  });

  watch(
    () => showStageMap.value,
    () => {
      zoom.value = 1;
    }
  );

  watch(
    () => router.currentRoute.value.params,
    () => {
      if (router.currentRoute.value.params.unauthorized) {
        isOpenedLoginOrCreateModal.value = true;
      }
    },
    { immediate: true }
  );
  onUnmounted(() => {
    resetPrimaryColor();

    if (isEmbedded) {
      observerEmbedded.disconnect();
    }
  });

  watch(
    () => router.currentRoute.value,
    () => {
      if (!router.currentRoute.value.query.lotId) {
        showReserveModal.value = false;
      }
    }
  );

const __returned__ = { mobileLayoutWidth, isDesktop, loginError, userData, isOpenedLoginOrCreateModal, isOpenedLoginModal, isOpenedRegistrationModal, isOpenedContactUsModal, isLoadingContactUsModal, isOpenedResetPasswordModal, isOpenedShareMapModal, zoom, estate, showStageMap, headerOverAll, showReserveModal, lotBuilderIconHover, lotForReserve, isQuestionWithLot, registrationMessage, forgotPasswordMessage, isOpenedInitialHoldModalWithPartner, successfulInitialRequestOpen, isOpenedInitialHoldModal, estateId, customerId, transitionName, urlRedirectAfterVerifyEmail, isEmbedded, defaultView, showLogo, viewType, isOpenedBuilderRequestQuoteModal, getBtnClassByViewType, pageview, currentUrl, track, toast, mouseX, mouseY, businessId, onRegister, embeddedOptions, showContactWithQuestion, backToReserve, onMessage, onCloseLoginOrCreateModal, onCloseLoginModal, onSelectLogin, onSelectCreate, closeLoginOrCreateModal, onCloseRegistrationModal, onCloseContactUsModal, onLogin, onJoin, onLoginFromRegistration, onForgotPassword, updateHeaderOverAll, onOpenPartnerModal, backToSelectHoldType, onHoldRequest, onCloseHoldRequest, onCloseHoldRequestWithPartner, onSendHoldRequest, onRequestQuote, onSendInResetPasswordModal, onCloseResetPasswordModal, signIn, signUp, onSendContactUsModal, fetchEstate, onReserve, closeReserveModal, onReserveLot, onLogout, onMyAccount, clearUnauthorizedParam, scrollToSavedPosition, openLoginModal, openRegistrationModal, changeView, handleResize, scrollTopEmbedded, updateZoom, checkEstateVersionAndRedirect, observerEmbedded, EstateMapEmbeddedOptions, HeaderCustomer, LoginOrCreateModal, LoginModal, RegistrationModal, ContactUsModal, EstateMap, StageMap, ReserveLotModal, ShareMapModal, SuccessInitialHoldModal, initialHoldWithPartnerModal, BuilderRequestQuoteModal, get useGtag() { return useGtag }, get store() { return store }, computed, onMounted, onUnmounted, ref, watch, get AuthParams() { return AuthParams }, get ContactUsForm() { return ContactUsForm }, get UserRoles() { return UserRoles }, get router() { return router }, get useEstateVersionRedirect() { return useEstateVersionRedirect }, get CreateUser() { return CreateUser }, get LotMapInterface() { return LotMapInterface }, get LocalStorageService() { return LocalStorageService }, ResetPasswordModal, get isLogged() { return isLogged }, get changePrimaryColor() { return changePrimaryColor }, get resetPrimaryColor() { return resetPrimaryColor }, StageList, get useIsDesktop() { return useIsDesktop }, InitialHoldModal, get MapPages() { return MapPages }, get EmbeddedMapQueries() { return EmbeddedMapQueries }, get POSITION() { return POSITION }, get useToast() { return useToast }, InfoWithIcon, get EstateInterface() { return EstateInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})